<div class="flex align-items-center header">
  <div class="col-4 white-space-nowrap overflow-hidden text-overflow-ellipsis">
    <!-- Если пользователь не залогинен или данные пользователя сохранены, тто показываем ссылку Стать оргом не основной странице или кнопку Назад на остальных-->
    <div *ngIf="!authService.user || authService.user?.setData">
      <!-- Стать оргом -->
      <a *ngIf="appSettings.currentUrlPath === ''" [routerLink]="['./org']" class="inputgroup-addon">
        {{ appSettings.translate[appSettings.selectedLang]["doorg"] }}
      </a>
      <!-- Назад -->
      <a *ngIf="appSettings.currentUrlPath !== ''" class="inputgroup-addon" href="javascript:void(0)"
        (click)="backClicked()">
        <i class="pi pi-arrow-left ico"></i>
      </a>
    </div>
  </div>
  <!-- Надпись MarshalOne -->
  <div class="col-4 center">
    <a href="/">
      <span class="logo bold">marshal</span>
      <span class="logo end">one</span>
    </a>
  </div>
  <div class="col-4 nopad">

    <div class="flex">

      <div class="white-space-nowrap overflow-hidden text-overflow-ellipsis text-right"
        style="margin-left: auto !important">

        <!-- Если пользователь залогинен и это не новый пользователь -->
        <ng-container *ngIf="authService.user && authService.user.name">
          <!-- Признак админа или бета тестера -->
          <span *ngIf="authService.user.admin">α </span>
          <span *ngIf="authService.user.betaTester">β </span>
          <!-- Аватар или заглушка -->
          <img [src]="
              authService.user?.photo
                ? appSettings.settings.urlFileDownload +
                  '/competitor/uid/' +
                  authService.user?.photo + '?width=20'
                : '/assets/avatar.png'
            " class="avatar" />
          <!-- Имя пользователя -->
          <span #userName (click)="menu.toggle($event)" class="inputgroup-addon overflow auth_link">{{
            authService.user.name }}</span>
          <!-- Меню перехода в профиль или логаут -->
          <p-menu appendTo="body" [baseZIndex]="99999" #menu [popup]="true" [model]="items"></p-menu>
        </ng-container>

        <!-- Если пользователь не залогинен или регистрируется новый -->
        <a *ngIf="!authService.user || !authService.user?.setData" (click)="showHideTopBar($event)" href="#"
          class="inputgroup-addon overflow">
          {{
          visibleTopBar || (appSettings.currentUrlPath && appSettings.currentUrlPath.includes('profile'))
          ? ""
          : appSettings.translate[appSettings.selectedLang]["auth"]
          }}
        </a>
      </div>
      <!-- Выбор языка -->
      <app-langs class="p-0 grid align-content-center m-0 flags"></app-langs>
    </div>
  </div>
</div>

<!-- Диалог авторизации -->
<p-dialog [header]="appSettings.translate[appSettings.selectedLang]['auth']" [(visible)]="visibleTopBar" [modal]="true"
  [responsive]="true">
  <race-auth (login)="loginNow($event)"
    (message)="detectChange($event)" [user]="authService.user"></race-auth>
</p-dialog>